<template>
    <div class="content-wraper login-register-area">
        <div class="container">
            <div class="row">
                <b-col cols="12">
                    <h2>Welkom op het klantenportaal van de Uitleendienst Erfgoed</h2>
                    Hier kan je als organisatie uit de cultureel-erfgoedsector materiaal ontlenen om je erfgoedcollectie beter te bewaren en te beheren.
                    Ben je benieuwd naar ons aanbod of wil je materiaal aanvragen? Log hier dan in of <router-link
                    :to="{ name: 'register' }"
                    class="text-primary">maak een nieuw gebruikersprofiel aan.</router-link>
                </b-col>
                <b-col cols="12">
                    <div class="customer-login-register">
                        <div class="login-Register-info">
                            <p class="coupon-input form-row-first">
                                <label>Gebruikersnaam of E-mailadres<span class="required">*</span></label>
                                <input
                                v-model="username"
                                class="form-control"
                                type="text"
                                name="username"
                                autocomplete="username">
                            </p>
                            <p class="coupon-input form-row-last">
                                <label>Wachtwoord<span class="required">*</span></label>
                                <input
                                v-model="password"
                                class="form-control"
                                type="password"
                                name="currentPassword"
                                autocomplete="current-password"
                                @keyup.enter="login()">
                            </p>
                            <div class="clear"/>
                            <p>
                                <button
                                value="lost-password"
                                name="password-reset"
                                class="button-login"
                                style="float: right;"
                                @click="lostPassword()">
                                    Wachtwoord vergeten
                                </button>
                                <button
                                value="Login"
                                name="login"
                                class="button-login"
                                @click="login()">
                                    Login
                                </button>
                            </p>
                        </div>
                    </div>
                </b-col>
            </div>
        </div>
    </div>
</template>

<script>
import AuthorizationService from '@/services/AuthorizationService.js'
import swal from 'sweetalert'

require('moment/locale/nl')
require('vue-moment')

export default {
    data () {
        return {
            username: '',
            password: '',
            termConditions: false,
            message: '',
            alert: ''
        }
    },
    mounted () {
        if (this.$route.query.code) {
            this.confirmUser()
        }
    },
    methods: {
        async login () {
            let basicAuth = {
                username: this.username + '',
                password: this.password + ''
            }

            try {
                let result = await AuthorizationService.login(basicAuth)
                let _this_ = this
                if (result.ExceptionLevel === 'SUCCESS') {
                    swal('', result.Message, result.ExceptionLevel.toLowerCase()).then(function () {
                        _this_.$router.push({name: 'home'})
                    })
                } else if (result.ExceptionLevel === 'WARNING') {
                    swal('', result.Message, result.ExceptionLevel.toLowerCase())
                } else {
                    this.$router.push({name: 'InternalError'})
                }
            } catch (err) {
                this.$router.push({name: 'InternalError'})
            }
        },

        async confirmUser () {
            await AuthorizationService.confirmUser(this.$route.query.code)
        },

        async lostPassword () {
            swal({title: 'Vul hieronder je e-mailadres in. Je ontvangt een e-mail waarmee je je wachtwoord kunt wijzigen.', content: 'input', button: 'Verzenden'}).then(async function (email) {
                let result = await AuthorizationService.lostPassword(email)
                return result
            }).then((result) => {
                let text = 'Sorry, je e-mailadres werd niet herkend door ons systeem. Je maakt best een nieuw gebruikersprofiel aan.'
                let icon = 'warning'
                if (result === 'SUCCESS') {
                    text = 'De e-mail is verzonden.'
                    icon = 'success'
                }
                swal('', text, icon)
            })
        }

    }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .card {
        margin-bottom: 15px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Authentication/Index.vue